import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const PageTransition: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const [opacity, setOpacity] = useState(1);
  const isFirstRender = useRef(true);
  const prevPath = useRef(location.pathname);

  useEffect(() => {
    // Skip animation on first render
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    // Only animate on actual path changes, not re-renders
    if (location.pathname === prevPath.current) return;
    prevPath.current = location.pathname;

    setOpacity(0);
    const t = requestAnimationFrame(() => {
      // Trigger fade-in on next frame
      setTimeout(() => setOpacity(1), 20);
    });
    return () => cancelAnimationFrame(t);
  }, [location.pathname]);

  return (
    <div
      style={{
        opacity,
        transition: 'opacity 0.25s ease-out',
        willChange: opacity < 1 ? 'opacity' : 'auto',
      }}
    >
      {children}
    </div>
  );
};

export default PageTransition;
